import {useMemo} from 'react';

import {FormSection} from '../../../../../../components/FormMaker/types';
import {ApplicantProfile} from '../../../types';

export const useStartDateSection = (profile: ApplicantProfile): FormSection[] => {
  return useMemo<FormSection[]>(
    () => [
      {
        type: 'earliest-start-date',
        data: {
          name: 'earliestStartDate',
          initialValue: profile.earliestStartDate || '',
        },
      },
    ],
    [profile.earliestStartDate]
  );
};
